module.exports = __webpack_public_path__ + "static/tempo-designing-82b4ccd42949355491afab0f35c6c5d0.gif";